import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function LegalShell({ title, kicker, children, testid }) {
  return (
    <div className="min-h-[100dvh] bg-ink pb-32 px-5 pt-8" data-testid={testid}>
      <Link to="/profile" className="inline-flex items-center gap-2 text-cream/60 hover:text-cream text-xs tracking-[0.2em] uppercase font-bold mb-4">
        <ArrowLeft size={14} /> Back
      </Link>
      <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">{kicker}</p>
      <h1 className="text-cream text-4xl font-black tracking-tighter mt-1">{title}</h1>
      <div className="jam-stripe h-[3px] w-24 rounded-full mt-3" aria-hidden />
      <div className="mt-8 space-y-5 text-cream/80 text-sm leading-relaxed max-w-2xl">
        {children}
      </div>
      <p className="mt-12 text-cream/40 text-xs">Last updated: 2026-02</p>
    </div>
  );
}
